import { render, staticRenderFns } from "./FreeSaldoFlagField.vue?vue&type=template&id=28e80f6a&scoped=true"
import script from "./FreeSaldoFlagField.vue?vue&type=script&lang=ts"
export * from "./FreeSaldoFlagField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e80f6a",
  null
  
)

export default component.exports